<template>
  <div>
    <div class="input-group">
      <div class="input-group-btn">
						<dropdown ref="dropdown">
              <btn type="default" class="dropdown-toggle">{{name}} <span class="caret"></span></btn>
              <template slot="dropdown">
                <li v-for="name in names" :key="name" @click="onNameChange(name)"><a role="button">{{name}}</a></li>
              </template>
            </dropdown>
					</div><!-- /btn-group -->
      <input type="text" v-model="current.url" class="form-control" aria-label="...">
      <div class="input-group-btn">
        <button type="button" class="btn btn-primary" @click="save">保存</button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>版本号</th>
            <th>地址</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in versions" :key="index" @click="onEditClick(item)">
            <td>{{item.version}}</td>
            <td>{{item.url}}</td>
            <td>
              <btn size="sm" type="danger" @click="onDeleteClick(item)">删除</btn>
              <btn size="sm" type="primary" @click="onEditClick(item)">修改</btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as types from '../store/types'
export default {
  data() {
    return {
      current: {},
      names: [
        'Laundry15.Desktop',
        'Laundry15.Installer'
      ],
      name: 'Laundry15.Desktop'
    }
  },
  mounted() {
    this.$store.dispatch(types.DO_GET_VERSIONS)
    .then(res => {

    })
    .catch(res => {

    })
  },
  computed: {
    versions() {
      return this.$store.state.versions.items.filter((val, index) => {
        return val.name === this.name
      })
    }
  },
  methods: {
    onNameChange(name) {
      this.name = name
    },
    onEditClick(item) {
      this.current = item
    },
    onDeleteClick(item) {
      this.$store
        .dispatch(types.DO_DELETE_VERSION, item)
        .then(res => {
          this.$notify({
            type: 'success',
            content: '删除成功'
          })
          this.$store
            .dispatch(types.DO_GET_VERSIONS)
            .then(res => {})
            .catch(res => {})
        })
        .catch(res => {
          this.$notify({
            type: 'danger',
            content: '删除失败'
          })
        })
    },
    save() {
      let type = ''
      if (this.current.id) {
        type = types.DO_UPDATE_VERSION
      } else {
        type = types.DO_CREATE_VERSION
      }
      const data = {
        name: this.name
      }
      this.$store
          .dispatch(type, Object.assign(data, this.current))
          .then(res => {
            this.$notify({
              type: 'success',
              content: '保存成功'
            })
            this.$store
            .dispatch(types.DO_GET_VERSIONS)
            .then(res => {})
            .catch(res => {})
          })
          .catch(res => {
            this.$notify({
              type: 'danger',
              content: '保存失败'
            })
          })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Versions.vue